import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";

const DeleteBulkClassRoomCreationIntentMutation = gql`
  mutation deleteBulkClassRoomCreationIntent($id: String!) {
    deleteBulkClassRoomCreationIntent(id: $id)
  }
`;

export function useDeleteBulkClassRoomCreationIntent() {
  const [deleteMutation, { loading }] = useMutation(
    DeleteBulkClassRoomCreationIntentMutation,
  );

  const deleteBulkClassRoomCreationIntent = useCallback(
    async (id: string) => {
      await deleteMutation({ variables: { id } });
    },
    [deleteMutation],
  );

  return {
    loading,
    deleteBulkClassRoomCreationIntent,
  };
}
